import React, { useState, useEffect } from 'react'
import Icon from '../../icon'
import globalData from '../../../common/globalData'
import './index.less'

export default ({ style, onClose, keyValue, alertIconStyle }) => {
  const [visible, setVisible] = useState(1)
  useEffect(() => {
    if (keyValue) {
      globalData.get(keyValue, setVisible, 1)
    }
  }, [])

  const _onClose = () => {
    if (keyValue) {
      globalData.set(keyValue, 0)
      setVisible(0)
    }
    onClose?.()
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>
    {!!visible && <div className="mn-recommend-tip">
      <div className="mn-recommend-tip-content" style={style}>
        <span className="content-left">
          <Icon type="m-xinxi_tianchong" className="alert-icon" style={alertIconStyle} />
          <div className="alert-message">采集越多，推荐越准哦，看见喜欢的图片就“采集”收藏进美念吧</div>
        </span>
        <div className="mn-alert-close" onClick={_onClose}>
          <Icon type="m-guanbi" />
        </div>
      </div>
    </div>}
  </>
}
